
import { Component, Ref, Vue } from 'vue-property-decorator'

/**
 * 手書きキャンバスタグ
 */
@Component
export default class DrawingCanvas extends Vue {
  /**
   * canvasタグアクセス用ref
   */
  @Ref()
  private canvasElement!: HTMLCanvasElement

  /**
   * canvasのcontext情報を保持する変数
   */
  private canvasContext: CanvasRenderingContext2D | null = null

  /** ドラッグ中かのフラグ */
  private isDragging = false

  /**
   * 描画コンテキストの参照用メソッド
   *
   * @returns canvasタグのコンテキスト
   */
  public get context(): CanvasRenderingContext2D {
    // 取得済みの場合はそのまま返す
    if (this.canvasContext) {
      return this.canvasContext
    }

    // 未取得の場合は取得して返す
    this.canvasContext = this.canvasElement.getContext('2d')

    // コンテキスト生成失敗時は例外を発生させる(実運用では発生しない想定)
    if (!this.canvasContext) {
      throw new Error('描画コンテキストの生成に失敗しました。')
    }

    return this.canvasContext
  }

  /**
   * canvasタグ本体の参照参照用メソッド
   *
   * @returns canvasタグのDOM要素
   */
  public get element(): HTMLCanvasElement {
    return this.canvasElement
  }

  /**
   * 初期処理
   */
  private mounted(): void {
    // canvasタグのサイズを実サイズに合わせて初期化
    this.canvasElement.height = this.canvasElement.offsetHeight
    this.canvasElement.width = this.canvasElement.offsetWidth
  }

  /**
   * ドラッグ開始イベント
   *
   * @param e htmlイベント
   */
  private dragStart(e: TouchEvent | MouseEvent): void {
    this.isDragging = true
    this.$emit('dragStart', e)
  }

  /**
   * ドラッグ終了
   *
   * @param e htmlイベント
   */
  private dragEnd(e: TouchEvent | MouseEvent): void {
    // ドラッグ中でない場合はイベントを発火しない
    if (!this.isDragging) {
      return
    }
    this.isDragging = false
    this.$emit('dragEnd', e)
  }

  /**
   * ドラッグ中イベント
   *
   * @param e htmlイベント
   */
  private dragging(e: TouchEvent | MouseEvent): void {
    // ドラッグ中のみイベントを発火させる
    if (this.isDragging) {
      this.$emit('dragging', e)
    }
  }
}
